import InvoicePayments from './InvoicePayments';

export default InvoicePayments;
